import React, { Component } from 'react';
import { Link } from 'react-router';
import TransactionItem from "./TransactionItem";
import { currency } from './../../../../../helpers/';
import { dateHelpers, genericHelpers } from '../../../../../helpers/';

class TransactionBasket extends Component {

    tax( total ){
        if( (this.props.currency && this.props.currency.common_country_id === 77) || (!this.props.currency && genericHelpers.siteOfOriginHelper() === 'gb') ){
            return [
                <div key="1" className="col-xs-3 col-sm-9 item-label">
                    { `Transaction Total (incl ${ currency.taxType() }):` }
                </div>,
                <div key="2" className="col-xs-9 col-sm-3">
                    { this.props.price === null ? 'Free' : currency.convert( total, 'gb' ) }
                </div>
            ];
        };
    }

    render() {

        const vat = Math.round( (this.props.price * 0.2) *100 ) / 100;
        const total = Math.round( ( this.props.price + vat ) * 100 ) / 100;
        const roundedPrice = Math.round( ( this.props.price ) * 100 ) /100;
        const formattedDate = dateHelpers.dateConverter( this.props.date );

        return (
            <div className="transactions-contents transaction-history-NED">
                <div className="row">
                    <div className="col-xs-12 col-md-3 basket-item-icon">
                        <span className="item-date">{ formattedDate }</span>
                            <br />
                            <span>
                            <Link to={`/account/transaction-receipt/${ this.props.transaction_id }`}>View Receipt</Link>
                        </span>
                    </div>
                    <div className="col-xs-12 col-md-9 basket-item-description">
                        { this.props.items.map((item, id) => {
                            if (item.package) {
                                const itemPackage = item.package;
                                return <TransactionItem
                                    key={id}
                                    id={item.id}
                                    type="Package"
                                    name={itemPackage.name}
                                    description={itemPackage.description}
                                    packageProducts={itemPackage.products}
                                />
                            } else {
                                const itemProduct = item.product;
                                return <TransactionItem
                                    key={id}
                                    type="Product"
                                    name={itemProduct.name}
                                    description={itemProduct.description}
                                />
                            }
                        }) }
                    </div>
                    <div className="col-xs-12 col-md-10 col-md-offset-2">
                    <div className="row transaction-total emphasis-color">
                        <div className="col-xs-3 col-sm-9 item-label">
                            Transaction Total:
                        </div>
                        <div className="col-xs-9 col-sm-3">
                            { this.props.price === null ? 'Free' : currency.convert( roundedPrice, (this.props.currency && this.props.currency.common_country_id === 77) || (!this.props.currency && genericHelpers.siteOfOriginHelper() === 'gb') ? 'gb' : 'us' ) }
                        </div>
                        { this.tax( total ) }
                    </div>
                </div>
                </div>
                <hr/>
            </div>
        );
    }
};

export default TransactionBasket;


// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/TransactionBasket.js